import { CustomerGroupDto } from '@symphony-solo/domain/customer-groups/src';
import { TransactionType } from '../enums';
import { TransactionLineProductDto } from './transaction-line-product.dto';
import { TransactionLineTenderDto } from './transaction-line-tender.dto';
import { TransactionTaxDto } from './transaction-tax.dto';

export class TransactionDto {
  public training: boolean;
  public transactionID: number;
  public takeAway: boolean;
  public transactionType: TransactionType;
  public customerGroup: CustomerGroupDto;
  public products: TransactionLineProductDto[];
  public taxes: TransactionTaxDto[];
  public tenders: TransactionLineTenderDto[];
  public netTotal: number;
  public taxTotal: number;
  public grossTotal: number;
}
